import React from 'react';
import styles from './Button.module.css';

const Button = ({ children, onClick, variant = 'default', disabled }) => (
  <button
    type="button"
    className={`${styles.button} ${styles[variant] || ''}`}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);

export default Button;
